import React, { useState } from "react";

import "./WithdrawalSection.scss";
import { useDraggableSheet } from "../../../helpers/hooks";
import { createPayout } from "../../Reducers/actions/accountActions";
import { fromCentsToPounds } from "../../../helpers/money";
import Icon from "../Icon";
import { useToast } from "../../hooks/useToast";
import { HYK_FEE_PERCENT_WITHDRAWAL } from "../../constants/globals";
function WithdrawalSection({ onClose, handleSuccess, lastFourDigits, bankAccountId, onPayoutRequirement }) {
    const [showFeesDetails, setShowFeesDetails] = useState(true);
    const [amount, setAmount] = useState(undefined);
    const [loading, setLoading] = useState(false)
    const toast = useToast();
    const { sheetStyle, overlayHandlers } = useDraggableSheet({ onClose });

    const handleWithdrawal = async () => {
        setLoading(true);
        const response = await createPayout((amount), bankAccountId);
        if (response.success) {
            handleSuccess();
        } else {
            if (response?.code === "FULL_KYC_REQUIRED" || response?.code === "KYC_REQUIRED") {
                onPayoutRequirement?.(response);
            }
            toast(response.message || 'Failed to withdraw money', "danger");

            console.error(response.message)
        }
        setLoading(false);
    };

  
    const getBaseAmount = (amount) => {
        
    
        return amount - (amount*HYK_FEE_PERCENT_WITHDRAWAL);

    }
    const getHykAmount = (amount) => {
       

        return amount*HYK_FEE_PERCENT_WITHDRAWAL;
        

    }

    return (
        <div className="withdrawal-section" {...overlayHandlers}>
            <div
                className={`sheet p-16`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >

                <div className="main-title pt-16 pb-8">Withdraw</div>

                <div className="input-box d-flex f-column mb-24">
                    <input
                        type="number"
                        id="amount"
                        name="amount"
                        inputMode="decimal"
                        className="input-field-secondary"
                        value={amount}
                        onChange={(e) => setAmount(parseFloat(e.target.value) || 0)}
                        placeholder="Other amount"
                        required
                    />
                    <div className="symbol">€</div>
                </div>

                <div className="summary-box pb-24 pt-16">
                    {amount && <div className="summary d-flex f-column">
                        <div className="d-flex f-row aic jcsb">
                            <span>{`You get exactly : `}
                            </span>
                            <span>{fromCentsToPounds(getBaseAmount(amount * 100))}</span>
                        </div>
                        <div className="d-flex f-row aic jcsb">
                            <div className="d-flex aic">
                                <span>{`HYK fees (${HYK_FEE_PERCENT_WITHDRAWAL*100}%): `}
                                </span>
                                <Icon alias={"warning_fees"} color={"#FF8CDC"} height={16} width={16} onClick={() => setShowFeesDetails((prev) => !prev)} />
                            </div>
                            <span>{fromCentsToPounds((getHykAmount(amount)) * 100)}</span>

                        </div>
                        {showFeesDetails && (
                            <div
                                style={{
                                    position: "relative",
                                    width: '100%',
                                    background: "#ff8cdc8d",
                                    color: "#FFF",
                                    padding: "8px 12px",
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    lineHeight: "1.4",
                                    zIndex: 1000,
                                    marginTop: "8px",
                                    marginBottom: "8px"
                                }}
                                onClick={() => setShowFeesDetails(false)}
                            >
                                <Icon alias={"warning_fees"} color={"#FFF"} height={16} width={16} />

                                <span className=""> {HYK_FEE_PERCENT_WITHDRAWAL > 0 
                                    ? `HYK charges a ${HYK_FEE_PERCENT_WITHDRAWAL * 100}% fee on each withdrawal to ensure a sustainable ecosystem.`
                                    : 'HYK currently charges no fees on withdrawals.'}
                                    {' '}You'll see the net amount here before confirming.</span>
                            </div>
                        )}
                        <div className="d-flex f-row aic jcsb">
                            <span>{`Total: `}
                            </span>
                            <span>{fromCentsToPounds(amount*100)}</span>
                        </div>

                    </div>}
                </div>

                <div className="bank-account-box pt-16">
                    <div className="title-box">withdraw to Bank account</div>
                    <div className="info pt-8">••••••••••••••••••{lastFourDigits}</div>
                </div>

                <div className="submit-box d-flex f-column aic jcc px-16 py-24">
                    <button

                        onClick={handleWithdrawal}
                        type="button"
                        disabled={((amount || 0) <= 0) || loading}
                        className="btn red-btn btn-full aic jcc fw-bold mb-16"
                    >
                        <span>WITHDRAWAL</span>
                    </button>
                    <div onClick={onClose} className="cancel-cta">Cancel</div>
                </div>
            </div>
        </div>
    );
}

export default WithdrawalSection;
